import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  staging: false,
  development: false,
  apiUrl: '',
  lmsUrl: '',
  label: '', // Empty for production
  notificatioHubUrl: '',
  secretKey: '',
};
